<template>
  <div>
    <b-card>
      <b-card-title
        class="fs-32 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center">
          <span> Meu plano </span>
        </div>
      </b-card-title>
      <b-card-text>
        <b-row class="d-flex align-items-center justify-content-between">
          <b-col cols="12" lg="6" class="fs-24"> Taxas de transações </b-col>
          <b-col cols="12" lg="6" class="fs-24 text-lg-right mt-3 mt-lg-0">
            <b-btn pill variant="primary" size="lg" @click="showContractPlan">
              <i class="fas fa-file-signature mr-2"></i>
              Ver contrato
            </b-btn>
          </b-col>
        </b-row>
      </b-card-text>
      <b-card-text class="mt-2">
        <b-row>
          <b-col cols="12">
            *Transferência só é feita de segunda a sexta, exceto feriados
            vigentes no município de São Paulo - Brasil.
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <b-card class="mt-4">
      <b-card-title
        class="fs-32 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center">
          <span> Opções de pagamento </span>
        </div>
      </b-card-title>
      <b-card-text>
        <b-card>
          <b-row class="d-flex align-items-center justify-content-between">
            <b-col cols="12" lg="6" class="fs-24"> Iugu </b-col>
            <b-col cols="12" lg="6" class="fs-24 text-lg-right mt-3 mt-lg-0">
              <b-btn
                pill
                :variant="paymentId == 1 ? 'success' : 'primary'"
                size="lg"
                @click="selectedPayment(1)"
              >
                {{ paymentId == 1 ? 'Selecionado' : 'Selecionar' }}
              </b-btn>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="mt-2">
          <b-row class="d-flex align-items-center justify-content-between">
            <b-col cols="12" lg="6" class="fs-24"> PagSeguro </b-col>
            <b-col cols="12" lg="6" class="fs-24 text-lg-right mt-3 mt-lg-0">
              <b-btn
                pill
                :variant="paymentId == 2 ? 'success' : 'primary'"
                size="lg"
                @click="selectedPayment(2)"
              >
                {{ paymentId == 2 ? 'Selecionado' : 'Selecionar' }}
              </b-btn>
            </b-col>

            <b-col cols="12" lg="12" v-if="paymentId == 2">
              <b-row>
                <b-col cols="12" lg="4">
                  <label>E-mail:</label>
                  <input
                    type="text"
                    v-model="pagseguro.email"
                    class="form-control"
                  />
                </b-col>

                <b-col cols="12" lg="8">
                  <label>Token:</label>
                  <input
                    type="text"
                    v-model="pagseguro.token"
                    class="form-control"
                  />
                </b-col>

                <b-col cols="12" lg="12" class="text-center mt-4">
                  <b-btn
                    pill
                    variant="success"
                    size="lg"
                    @click="savePaymentOptions()"
                  >
                    Salvar
                  </b-btn>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="mt-2">
          <b-row class="d-flex align-items-center justify-content-between">
            <b-col cols="12" lg="6" class="fs-24"> GetNet </b-col>
            <b-col cols="12" lg="6" class="fs-24 text-lg-right mt-3 mt-lg-0">
              <b-btn
                pill
                :variant="paymentId == 3 ? 'success' : 'primary'"
                size="lg"
                @click="selectedPayment(3)"
              >
                {{ paymentId == 3 ? 'Selecionado' : 'Selecionar' }}
              </b-btn>
            </b-col>

            <b-col cols="12" lg="12" v-if="paymentId == 3">
              <b-row>
                <b-col cols="12" lg="4">
                  <label>Client ID:</label>
                  <input
                    type="text"
                    v-model="getnet.client_id"
                    class="form-control"
                  />
                </b-col>

                <b-col cols="12" lg="4">
                  <label>Client Secret:</label>
                  <input
                    type="text"
                    v-model="getnet.client_secret"
                    class="form-control"
                  />
                </b-col>

                <b-col cols="12" lg="4">
                  <label>Saller ID:</label>
                  <input
                    type="text"
                    v-model="getnet.saller_id"
                    class="form-control"
                  />
                </b-col>

                <b-col cols="12" lg="12" class="text-center mt-4">
                  <b-btn
                    pill
                    variant="success"
                    size="lg"
                    @click="savePaymentOptions()"
                  >
                    Salvar
                  </b-btn>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-card-text>
    </b-card>

    <ShopkeeperAppContract />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
import ShopkeeperAppContract from 'Components/Contract/ShopkeeperAppContract.vue';

export default {
  name: 'PlanCard',
  mixins: [makeToast],
  components: { ShopkeeperAppContract },
  data() {
    return {
      paymentId: 1,
      pagseguro: {
        email: '',
        token: '',
        construp_user_id: '',
      },
      getnet: {
        client_id: '',
        client_secret: '',
        saller_id: '',
        construp_user_id: '',
      },
    };
  },

  props: {
    desativarComissao: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  created() {
    this.getPayment();
  },
  methods: {
    showContractPlan() {
      this.$bvModal.show('shopkeeper-app-contract');
    },
    getPayment() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/getPaymentOptions', this.dadosUsuario.id)
        .then((response) => {
          this.paymentId = response.data.paymentId;
          if (this.paymentId == 2) {
            this.pagseguro = response.data.payment;
          } else if (this.paymentId == 3) {
            this.getnet = response.data.payment;
          }

          this.$store.dispatch('endLoader');
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast(
            'Ooops',
            `Parece que algo deu errado, tente novamente`,
            'danger'
          );
        });
    },
    selectedPayment(paymentId) {
      this.paymentId = paymentId;

      const data = {
        paymentId: paymentId,
        construp_user_id: this.dadosUsuario.id,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/selectedPayment', data)
        .then((response) => {
          if (paymentId == 2 && response.data.email) {
            this.pagseguro = response.data;
          } else if (paymentId == 3 && response.data.client_id) {
            this.getnet = response.data;
          }
          this.$store.dispatch('endLoader');
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast(
            'Ooops',
            `Parece que algo deu errado, tente novamente`,
            'danger'
          );
        });
    },
    savePaymentOptions() {
      if (
        this.paymentId == 2 &&
        (this.pagseguro.email == '' || this.pagseguro.token == '')
      ) {
        this.makeToast(
          'Error',
          `Informe o E-mail e o token para salvar!`,
          'warning'
        );
        return;
      }

      if (
        this.paymentId == 3 &&
        (this.getnet.client_id == '' ||
          this.getnet.client_secret == '' ||
          this.getnet.saller_id == '')
      ) {
        this.makeToast(
          'Error',
          `Informe o Client ID, Client Secret e o Saller ID para salvar!`,
          'warning'
        );
        return;
      }

      const data = {
        paymentId: this.paymentId,
        getnet: this.getnet,
        pagseguro: this.pagseguro,
        construp_user_id: this.dadosUsuario.id,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/savePaymentOptions', data)
        .then((response) => {
          if (response.data.error) {
            this.makeToast(
              'Ooops',
              `Parece que algo deu errado, tente novamente`,
              'danger'
            );
          } else {
            this.makeToast(
              'Sucesso',
              `Informações salvas com sucesso`,
              'success'
            );
          }

          this.$store.dispatch('endLoader');
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast(
            'Ooops',
            `Parece que algo deu errado, tente novamente`,
            'danger'
          );
        });
    },
  },
};
</script>
